export const baseURL = "https://roulette.drfit.site/";
export const adminBaseURL = "https://swo.drfit.site/";
export const key = "133e1f54e11f90ef6d7a";
